var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"summary-card",attrs:{"outlined":"","elevation":"1"}},[_c('v-card-text',{staticClass:"text-center",attrs:{"py-6":""}},[_c('h5',{staticClass:"text-h5 mb-3"},[_vm._v(_vm._s(_vm.title))]),_c('h6',{staticClass:"text-h6 primary--text"},[_vm._v(_vm._s(_vm.amount))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }